<template>
  <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="1000px">
    <v-card>
      <v-form v-on:submit.prevent="createItem">
        <v-card-title>
          <span class="headline">{{ modal_title }}</span>
        </v-card-title>

        <v-card-text style="background-color: #f5f5f5;">
          <!-- START FORM DIALOG -->
          <div class="row">
            <div class="col-md-12">
              <!-- Panel de Expansión para diferentes secciones -->
              <v-expansion-panels v-model="panelExpanded" multiple flat>
                <!-- DATOS FISCALES -->
                <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                  <v-expansion-panel-header style="background-color: white;">
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="primary">business</v-icon>
                      <span class="text-h6 font-weight-medium">Datos Fiscales</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="background-color: white;">
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="d-flex">
                          <v-text-field
                            autocomplete="off"
                            data-vv-as="cuit"
                            label="CUIT (solo numeros)"
                            name="cuit"
                            v-validate="{
                              required: false,
                              regex: /\b(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
                            }"
                            v-model="item.cuit"
                            :disabled="isViewModal()"
                            class="mr-2"
                          ></v-text-field>
                          <v-btn 
                            color="blue-grey" 
                            class="text-white mt-3" 
                            @click="query_padron()" 
                            :loading="loading_search_afip"
                            style="min-width: 100px;"
                          > 
                            <font-awesome-icon icon="search" class="mr-2" /> ARCA 
                          </v-btn>
                        </div>
                        <span class="red--text">{{ errors.first("cuit") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field 
                          data-vv-as="Razon Social" 
                          label="Razón social*" 
                          name="business_name" 
                          v-model="item.business_name" 
                          v-validate="'required'" 
                          :disabled="isViewModal()"
                        ></v-text-field>
                        <span class="red--text">{{ errors.first("business_name") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field 
                          data-vv-as="name" 
                          label="Nombre*" 
                          name="name" 
                          v-model="item.name" 
                          v-validate="'required'" 
                          :disabled="isViewModal()"
                        ></v-text-field>
                        <span class="red--text">{{ errors.first("name") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox
                          label="Condición frente al IVA*"
                          v-model="item.iva_condition"
                          data-vv-as="Condición frente al IVA"
                          name="iva_condition"
                          :items="iva_conditions"
                          item-text="name"
                          item-value="id"
                          autocomplete="off"
                          v-validate="'required|combobox_required'"
                          :disabled="isViewModal()"
                        ></v-combobox>
                        <span class="red--text">{{ errors.first("iva_condition") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox
                          label="Tipo de persona"
                          v-model="item.tipo_persona"
                          data-vv-as="Tipo de persona"
                          name="tipo_persona"
                          :items="tipo_persona_options"
                          item-text="name"
                          item-value="id"
                          autocomplete="off"
                          :disabled="isViewModal()"
                        ></v-combobox>
                        <span class="red--text">{{ errors.first("tipo_persona") }}</span>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- DATOS DE CONTACTO -->
                <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                  <v-expansion-panel-header style="background-color: white;">
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="primary">contacts</v-icon>
                      <span class="text-h6 font-weight-medium">Datos de Contacto</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="background-color: white;">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field 
                          data-vv-as="Email" 
                          label="Email" 
                          name="email" 
                          v-model="item.email" 
                          :disabled="isViewModal()"
                          hint="Si desea agregar mas de un email debe separarlo con ', '"
                          persistent-hint
                        ></v-text-field>
                        <span class="red--text">{{ errors.first("email") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field 
                          data-vv-as="Telefono" 
                          label="Telefono" 
                          name="telephone" 
                          v-model="item.telephone" 
                          :disabled="isViewModal()"
                        ></v-text-field>
                        <span class="red--text">{{ errors.first("telefono") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field 
                          data-vv-as="Direccion" 
                          label="Dirección" 
                          name="address" 
                          v-model="item.address" 
                          :disabled="isViewModal()"
                        ></v-text-field>
                        <span class="red--text">{{ errors.first("address") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox
                          v-model="item.provincia"
                          autocomplete="off"
                          data-vv-as="provincia"
                          name="provincia"
                          item-text="name"
                          item-value="id"
                          :items="provincias"
                          label="Provincia"
                          clearable
                          :disabled="isViewModal()"
                        ></v-combobox>
                        <span class="red--text">{{ errors.first("provincia") }}</span>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- DATOS BANCARIOS -->
                <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                  <v-expansion-panel-header style="background-color: white;">
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="primary">account_balance</v-icon>
                      <span class="text-h6 font-weight-medium">Datos Bancarios</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="background-color: white;">
                    <v-row class="mb-3">
                      <v-col md="12" v-if="!isViewModal()">
                        <v-btn small color="blue-grey" class="pl-4 text-white" @click="addSupplierBank()">
                          <v-icon small color="white" class="mr-2">add</v-icon>
                          <span>Agregar banco</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-data-table
                      :headers="header_supplier_banks"
                      :items="item.supplier_banks"
                      style="border: solid 1px #e0e0e0"
                      :hide-default-footer="true"
                      :items-per-page="100"
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td>
                            <v-text-field
                              v-model="props.item.bank_name"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              placeholder="Nombre del banco"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="props.item.cbu_alias"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              placeholder="CBU / CVU / Alias"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="props.item.description"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              placeholder="Descripción"
                            />
                          </td>
                          <td class="text-center">
                            <v-checkbox
                              v-model="props.item.is_default"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              class="mt-0 pt-0 d-inline-flex"
                              @change="props.item.is_default && setDefaultBank(props.item)"
                            />
                          </td>
                          <td class="text-center">
                            <v-checkbox
                              v-model="props.item.enabled"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              class="mt-0 pt-0 d-inline-flex"
                            />
                          </td>
                          <td class="text-center">
                            <v-tooltip bottom v-if="!isViewModal() && !props.item.id">
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small color="red" @click="removeSupplierBank(props.item)">delete</v-icon>
                              </template>
                              <span>Remover</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- DATOS ADICIONALES -->
                <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                  <v-expansion-panel-header style="background-color: white;">
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="primary">settings</v-icon>
                      <span class="text-h6 font-weight-medium">Datos Adicionales</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="background-color: white;">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field 
                          data-vv-as="Identificador externo" 
                          label="Identificador externo" 
                          name="external_reference" 
                          v-model="item.external_reference" 
                          :disabled="isViewModal()"
                        ></v-text-field>
                        <span class="red--text">{{ errors.first("external_reference") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox
                          v-model="item.type"
                          autocomplete="off"
                          data-vv-as="tipo"
                          name="type"
                          item-text="name"
                          item-value="id"
                          :items="supplier_types"
                          label="Tipo de proveedor"
                          clearable
                          :disabled="isViewModal()"
                        ></v-combobox>
                        <span class="red--text">{{ errors.first("type") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field
                          type="number"
                          hint="Ingresa la cantidad de dias que deben pasar para considerar el pago de una factura atrasado"
                          persistent-hint
                          data-vv-as="Pago atrasado"
                          label="Pago atrasado (días)"
                          name="invoice_expiration"
                          v-model="item.invoice_expiration"
                          :disabled="isViewModal()"
                        ></v-text-field>
                        <span class="red--text">{{ errors.first("invoice_expiration") }}</span>
                      </v-col>

                      <v-col cols="12" md="6">
                        <ConceptoCentroPicker
                          :concepto.sync="item.concepto"
                          :cost_center.sync="item.cost_center"
                          :conceptos="conceptos"
                          :cost_centers="cost_centers"
                          :disabled="isViewModal()"
                        />
                        <div class="text-caption grey--text mt-1">
                          Asocia un centro de costo y concepto para asignar automáticamente los gastos de este proveedor
                        </div>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-checkbox 
                          label="Habilitado" 
                          :disabled="isViewModal()" 
                          v-model="item.enabled"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- IMPUESTOS INSCRIPTOS -->
                <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                  <v-expansion-panel-header style="background-color: white;">
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="primary">receipt</v-icon>
                      <span class="text-h6 font-weight-medium">Impuestos Inscriptos</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="background-color: white;">
                    <p class="text-body-2 mb-3">Impuestos a los que está inscripto el proveedor</p>
                    <v-row class="mb-3">
                      <v-col md="12" v-if="!isViewModal()">
                        <v-btn small color="blue-grey" class="pl-4 text-white" @click="addImpuestoInscripto()">
                          <v-icon small color="white" class="mr-2">add</v-icon>
                          <span>Agregar impuesto</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-data-table
                      :headers="header_impuestos"
                      :items="item.impuesto_inscripto"
                      style="border: solid 1px #e0e0e0"
                      :hide-default-footer="true"
                      :items-per-page="100"
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td>
                            <v-combobox
                              :items="impuestos"
                              item-text="name"
                              item-value="id"
                              v-model="props.item.impuesto"
                              :disabled="isViewModal()"
                              dense
                              placeholder="Seleccione una retención"
                              hide-details
                            />
                          </td>
                          <td class="text-center">
                            <v-tooltip bottom v-if="!isViewModal()">
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small color="red" @click="removeImpuestoInscripto(props.item)">delete</v-icon>
                              </template>
                              <span>Remover</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- IMPUESTOS EXENTOS -->
                <v-expansion-panel class="mb-2" style="border: 1px solid #e0e0e0; border-radius: 4px; background-color: white;">
                  <v-expansion-panel-header style="background-color: white;">
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="primary">money_off</v-icon>
                      <span class="text-h6 font-weight-medium">Impuestos Exentos</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="background-color: white;">
                    <p class="text-body-2 mb-3">Impuestos en los que el proveedor está exento</p>
                    <v-row class="mb-3">
                      <v-col md="12" v-if="!isViewModal()">
                        <v-btn small color="blue-grey" class="pl-4 text-white" @click="addImpuestoExcento()">
                          <v-icon small color="white" class="mr-2">add</v-icon>
                          <span>Agregar exención</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-data-table
                      :headers="header_impuestos_excento"
                      :items="item.impuesto_excento"
                      style="border: solid 1px #e0e0e0"
                      :hide-default-footer="true"
                      :items-per-page="100"
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td>
                            <v-combobox
                              :items="impuestos"
                              item-text="name"
                              item-value="id"
                              v-model="props.item.impuesto"
                              :disabled="isViewModal()"
                              dense
                              placeholder="Seleccione"
                              hide-details
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="props.item.certificado_de_excencion"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              placeholder="Nro. certificado"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="props.item.porcentaje_de_excencion"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              type="number"
                              placeholder="0.00"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="props.item.desde"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              type="date"
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="props.item.hasta"
                              :disabled="isViewModal()"
                              dense
                              hide-details
                              type="date"
                              clearable
                            />
                          </td>
                          <td>
                            <div v-if="!isViewModal()">
                              <v-file-input
                                v-model="props.item.certificado_file"
                                dense
                                hide-details
                                accept=".pdf,.jpg,.jpeg,.png"
                                placeholder="Adjuntar"
                                prepend-icon="attach_file"
                                @change="onCertificadoFileChange($event, props.item)"
                              />
                            </div>
                            <div v-else-if="props.item.certificado_path">
                              <v-icon small>attach_file</v-icon>
                              <span class="caption">{{ props.item.certificado_path.split('/').pop() }}</span>
                            </div>
                          </td>
                          <td class="text-center">
                            <v-tooltip bottom v-if="!isViewModal()">
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small color="red" @click="removeImpuestoExcento(props.item)">delete</v-icon>
                              </template>
                              <span>Remover</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
          <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import Constant from "@/constants/sections";
import { billingGeneralService } from "@/libs/ws/billingGeneralService";
import { receiversService } from "@/libs/ws/receiversService";
import { generalService } from "@/libs/ws/generalService";
import ConceptoCentroPicker from "@/components/ConceptoCentroPicker.vue";

export default {
  mixins: [ModalGenericMixin],
  components: { ConceptoCentroPicker },
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      show: false,
      panelExpanded: [0, 1, 2, 3, 4, 5], // Todos los paneles abiertos por defecto
      iva_conditions: [],
      tipo_persona_options: [
        { id: "H", name: "Humana" },
        { id: "J", name: "Juridica" },
      ],
      loading_search_afip: false,
      supplier_types: [],
      provincias: [],
      impuestos: [],
      header_impuestos: [
        { text: "Impuesto", value: "impuesto", sortable: false },
        { text: "Acción", value: "", sortable: false, align: "center" },
      ],
      header_impuestos_excento: [
        { text: "Impuesto", value: "impuesto", sortable: false },
        { text: "Certificado", value: "certificado_de_excencion", sortable: false },
        { text: "% Excención", value: "porcentaje_de_excencion", sortable: false, width: "110px" },
        { text: "Desde", value: "desde", sortable: false, width: "140px" },
        { text: "Hasta", value: "hasta", sortable: false, width: "140px" },
        { text: "Adjunto", value: "certificado_path", sortable: false },
        { text: "Acción", value: "", sortable: false, align: "center", width: "70px" },
      ],
      header_supplier_banks: [
        { text: "Banco", value: "bank_name", sortable: false },
        { text: "CBU/CVU/Alias", value: "cbu_alias", sortable: false },
        { text: "Descripción", value: "description", sortable: false },
        { text: "Default", value: "is_default", sortable: false, align: "center", width: "80px" },
        { text: "Habilitado", value: "enabled", sortable: false, align: "center", width: "90px" },
        { text: "Acción", value: "", sortable: false, align: "center", width: "70px" },
      ],
      conceptos: [],
      cost_centers: [],
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    "item.email"(newVal) {
      if (newVal && typeof newVal === 'string') {
        // Normalizar: agregar espacio después de coma si no existe
        // Reemplazar ", " múltiples o "," sin espacio por ", "
        const normalized = newVal
          .replace(/,\s*/g, ', ') // Reemplaza coma con/sin espacios por coma-espacio
          .replace(/,\s+/g, ', '); // Normaliza múltiples espacios a uno solo
        
        if (normalized !== newVal) {
          this.$nextTick(() => {
            this.item.email = normalized;
          });
        }
      }
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() {
    this.loadIVAConditions();
    this.loadSupplierTypes();
    this.loadProvincias();
    this.loadImpuestos();
    this.loadConceptosAndCenters();
  },
  methods: {
    loadIVAConditions() {
      billingGeneralService.list_iva_conditions({for_emitter: false}).then((response) => {
        this.iva_conditions = response.result;
      });
    },
    isViewModal() {
      return this.formBtn == "";
    },
    loadConceptosAndCenters() {
      generalService.setSection(Constant.SECTION_CONCEPTOS);
      generalService.filter().then((r) => { this.conceptos = r.result; }).catch(() => {});

      generalService.setSection(Constant.SECTION_COSTS_CENTERS);
      generalService.filter().then((r) => {
        this.cost_centers = r.result.map((cc) => ({ id: cc.id, name: cc.name }));
      }).catch(() => {});
    },
    loadSupplierTypes() {
      generalService.setSection(Constant.SECTION_SUPPLIER_TYPE);
      generalService
        .filter()
        .then((response) => {
          this.supplier_types = response.result;
        })
        .catch((e) => {
          console.log("supplier_types.filter error");
          console.log(e);
        });
    },
    loadProvincias() {
      generalService.setSection(Constant.SECTION_PROVINCIAS);
      generalService.filter().then((response) => {
        this.provincias = response.result;
      });
    },
    loadImpuestos() {
      generalService.setSection(Constant.SECTION_IMPUESTOS);
      generalService.filter().then((response) => {
        this.impuestos = response.result;
      });
    },
    addSupplierBank() {
      this.item.supplier_banks.push({
        id: null,
        bank_name: "",
        cbu_alias: null,
        description: null,
        is_default: this.item.supplier_banks.length === 0,
        enabled: true,
      });
    },
    removeSupplierBank(bank) {
      const idx = this.item.supplier_banks.indexOf(bank);
      this.item.supplier_banks.splice(idx, 1);
      // Si se eliminó el default y quedan bancos, marcar el primero
      if (bank.is_default && this.item.supplier_banks.length > 0) {
        this.item.supplier_banks[0].is_default = true;
      }
    },
    setDefaultBank(selectedBank) {
      this.item.supplier_banks.forEach((b) => {
        b.is_default = b === selectedBank;
      });
    },
    addImpuestoInscripto() {
      this.item.impuesto_inscripto.push({ id: null, impuesto: null });
    },
    removeImpuestoInscripto(item) {
      this.item.impuesto_inscripto.splice(this.item.impuesto_inscripto.indexOf(item), 1);
    },
    addImpuestoExcento() {
      this.item.impuesto_excento.push({
        id: null,
        impuesto: null,
        certificado_de_excencion: null,
        porcentaje_de_excencion: null,
        desde: null,
        hasta: null,
        certificado_path: null,
        certificado_file: null,
        certificado_file_base64: null,
        certificado_file_ext: null,
      });
    },
    removeImpuestoExcento(item) {
      this.item.impuesto_excento.splice(this.item.impuesto_excento.indexOf(item), 1);
    },
    onCertificadoFileChange(file, item) {
      if (!file) {
        item.certificado_file_base64 = null;
        item.certificado_file_ext = null;
        return;
      }
      item.certificado_file_ext = file.name.split(".").pop();
      const reader = new FileReader();
      reader.onload = (e) => {
        item.certificado_file_base64 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    query_padron() {
      if (this.item.cuit != null && this.item.cuit != "") {
        this.loading_search_afip = true;
        receiversService
          .query_padron({
            tax_id: this.item.cuit,
            doc_type: 80, //CUIT
          })
          .then((response) => {
            console.log(response);
            if (response.status == true) {
              this.item.business_name = response.result.name;
              this.item.name = response.result.name;
              this.item.address = response.result.address;
              this.item.location = response.result.location;
              this.item.postal_code = response.result.postal_code;

              if (response.result.iva_condition != undefined && response.result.iva_condition != null) {
                this.item.iva_condition = this.iva_conditions.find((x) => x.id == response.result.iva_condition);
              }
            } else {
              this.$toast.error(response.msg, "Error");
            }
          })
          .catch((response) => {
            console.log(response);
            this.$toast.error(response.msg, "Error");
          })
          .finally(() => {
            this.loading_search_afip = false;
          });
      }
    },
    createItem(e) {
      if (this.loading) return;

      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();
          const data = {
            id: this.item.id,
            name: this.item.name,
            cuit: this.item.cuit,
            iva_condition: this.item.iva_condition != null ? this.item.iva_condition.id : null,
            telephone: this.item.telephone,
            email: this.item.email,
            business_name: this.item.business_name,
            external_reference: this.item.external_reference,
            invoice_expiration: this.item.invoice_expiration,
            enabled: this.item.enabled,
            type: this.item.type,
            cbu_alias: this.item.cbu_alias,
            bank_name: this.item.bank_name,
            provincia_id: this.item.provincia ? this.item.provincia.id : null,
            tipo_persona: this.item.tipo_persona ? (typeof this.item.tipo_persona === 'object' ? this.item.tipo_persona.id : this.item.tipo_persona) : null,
            impuesto_inscripto_arr: this.item.impuesto_inscripto
              .filter((r) => r.impuesto && r.impuesto.id)
              .map((r) => ({ id: r.id > 0 ? r.id : null, impuesto_id: r.impuesto.id })),
            impuesto_excento_arr: this.item.impuesto_excento
              .filter((r) => r.impuesto && r.impuesto.id)
              .map((r) => ({
                id: r.id > 0 ? r.id : null,
                impuesto_id: r.impuesto.id,
                certificado_de_excencion: r.certificado_de_excencion || null,
                porcentaje_de_excencion: r.porcentaje_de_excencion || null,
                desde: r.desde || null,
                hasta: r.hasta || null,
                certificado_file_base64: r.certificado_file_base64 || null,
                certificado_file_ext: r.certificado_file_ext || null,
              })),
            supplier_banks_arr: this.item.supplier_banks
              .filter((b) => b.bank_name)
              .map((b) => ({
                id: b.id > 0 ? b.id : null,
                bank_name: b.bank_name,
                cbu_alias: b.cbu_alias || null,
                description: b.description || null,
                is_default: b.is_default || false,
                enabled: b.enabled !== false,
              })),
            concepto: this.item.concepto != null ? { id: this.item.concepto.id } : null,
            cost_center: this.item.cost_center != null ? { id: this.item.cost_center.id } : null,
          };

          this.loading = true;
          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("El " + this.modal_title + " se modifico correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          } else {
            this.service
              .create(data)
              .then((response) => {
                console.log(response);
                if (response.status) {
                  this.$toast.success("El " + this.modal_title + " se creo correctamente", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((response) => {
                console.log(response);
                this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          }
        }
      });
    },
  },
};
</script>
